document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("hero-video")) {
    customElements.define(
      "hero-video",
      class HeroVideo extends HTMLElement {
        constructor() {
          super();
          this.video = this.querySelector("video");
          this.videoDeskSrc = this.video.getAttribute("data-src");
          this.videoMobileSrc = this.video.getAttribute("data-mobile-src");
          this.prevWidth = window.innerWidth;

          this.changeVideoSource = this.changeVideoSource.bind(this);
          window.addEventListener("resize", () => {
            if (Math.abs(window.innerWidth - this.prevWidth) > 50) {
              this.changeVideoSource();
            }
          });
          this.changeVideoSource();
        }

        connectedCallback() {
          const handleIntersection = (entries, observer) => {
            try {
              if (!this.video) return;
              if (entries[0].isIntersecting) {
                this.video.play();
              } else {
                this.video.pause();
              }
            } catch (error) {
              console.log(error);
            }
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            threshold: 0.5,
          }).observe(this.video);
        }
        changeVideoSource() {
          if (!this.video) return;

          const currentWidth = window.innerWidth;
          let newSrc;
          if (window.innerWidth >= 993 && this.videoDeskSrc) {
            newSrc = this.videoDeskSrc;
          } else if (window.innerWidth < 993 && this.videoMobileSrc) {
            newSrc = this.videoMobileSrc;
          } else {
            this.video.removeAttribute("src");
          }

          if (newSrc && newSrc !== this.video?.src) {
            this.video.src = newSrc;
          }
          this.prevWidth = currentWidth;
        }
      }
    );
  }
});
